var Stack = require("./_Stack"), assignMergeValue = require("./_assignMergeValue"), baseFor = require("./_baseFor"), baseMergeDeep = require("./_baseMergeDeep"), isObject = require("./isObject"), keysIn = require("./keysIn"), safeGet = require("./_safeGet");
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
module.exports = baseMerge;
